/**
 * Web Style Import
 *
 */

import './dnb-section.scss'
